import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import { CartProvider } from "@/context/CartContext";
import { SettingsProvider } from "@/context/SettingsContext";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Portfolio from "@/pages/Portfolio";
import Shop from "@/pages/Shop";
import Contact from "@/pages/Contact";
import Commissions from "@/pages/Commissions";
import Journal from "@/pages/Journal";
import JournalPost from "@/pages/JournalPost";
import Admin from "@/pages/Admin";
import CheckoutSuccess from "@/pages/CheckoutSuccess";

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <CartProvider>
          <BrowserRouter>
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                background: "#3B4A3F",
                color: "#F7F6F2",
                border: "1px solid #2C382F",
                borderRadius: "2px",
                fontFamily: "Outfit, sans-serif",
                fontSize: "13px",
                letterSpacing: "0.02em",
              },
            }}
          />
          <Layout>
            <AnalyticsTracker />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/commissions" element={<Commissions />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/journal/:slug" element={<JournalPost />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        </CartProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
